import { ApdmCampaignKind, kApdmDefaultDailyCap } from '@euler/model/apdm';
import { useEffect, useState } from 'react';
import { ReviewField } from '../../imports/ReviewControls';
import {
  WizardFormProps,
  WizardNumberField,
  WizardToggle,
} from './WizardControls';
export function WizardSchedule({ draft, disabled, onChange }: WizardFormProps) {
  const [delays, setDelays] = useState(
    draft.policy.followUpDelaysDays.join(','),
  );
  useEffect(() => {
    if (draft.policy.followUpDelaysDays.every(Number.isFinite))
      setDelays(draft.policy.followUpDelaysDays.join(','));
  }, [draft.policy.followUpDelaysDays]);
  return (
    <>
      <ReviewField
        label="开始时间（ISO UTC，例如 2026-12-01T01:00:00Z）"
        value={draft.schedule.startAt ?? ''}
        disabled={disabled}
        onChange={startAt =>
          onChange({
            ...draft,
            schedule: { ...draft.schedule, startAt: startAt || null },
          })
        }
      />
      <ReviewField
        label="结束时间（可选，ISO UTC）"
        value={draft.schedule.endAt ?? ''}
        disabled={disabled}
        onChange={endAt =>
          onChange({
            ...draft,
            schedule: { ...draft.schedule, endAt: endAt || null },
          })
        }
      />
      <ReviewField
        label="每日发送开始（门店时间 HH:mm）"
        value={draft.schedule.dailyWindow.from}
        disabled={disabled}
        onChange={from =>
          onChange({
            ...draft,
            schedule: {
              ...draft.schedule,
              dailyWindow: { ...draft.schedule.dailyWindow, from },
            },
          })
        }
      />
      <ReviewField
        label="每日发送结束（门店时间 HH:mm）"
        value={draft.schedule.dailyWindow.to}
        disabled={disabled}
        onChange={to =>
          onChange({
            ...draft,
            schedule: {
              ...draft.schedule,
              dailyWindow: { ...draft.schedule.dailyWindow, to },
            },
          })
        }
      />
      <WizardToggle
        label="不限制每日触达数"
        value={draft.schedule.dailyCap === null}
        disabled={disabled}
        onChange={unlimited =>
          onChange({
            ...draft,
            schedule: {
              ...draft.schedule,
              dailyCap: unlimited ? null : kApdmDefaultDailyCap,
            },
          })
        }
      />
      {draft.schedule.dailyCap !== null && (
        <WizardNumberField
          label="每日触达上限"
          value={draft.schedule.dailyCap}
          disabled={disabled}
          onChange={dailyCap =>
            onChange({ ...draft, schedule: { ...draft.schedule, dailyCap } })
          }
        />
      )}
      <ReviewField
        label="跟进间隔天数（最多两项，逗号分隔；问候活动不跟进）"
        value={delays}
        disabled={disabled || draft.kind === ApdmCampaignKind.Greeting}
        onChange={value => {
          setDelays(value);
          onChange({
            ...draft,
            policy: {
              ...draft.policy,
              followUpDelaysDays: value.trim()
                ? value
                    .split(',')
                    .map(text =>
                      /^\d+$/.test(text.trim()) ? Number(text.trim()) : NaN,
                    )
                : [],
            },
          });
        }}
      />
      <WizardNumberField
        label="延迟跟进宽限天数"
        value={draft.policy.lateFollowUpGraceDays}
        disabled={disabled}
        onChange={lateFollowUpGraceDays =>
          onChange({
            ...draft,
            policy: { ...draft.policy, lateFollowUpGraceDays },
          })
        }
      />
      <WizardNumberField
        label="跨活动冷却天数"
        value={draft.policy.crossCampaignCooldownDays}
        disabled={disabled}
        onChange={crossCampaignCooldownDays =>
          onChange({
            ...draft,
            policy: { ...draft.policy, crossCampaignCooldownDays },
          })
        }
      />
      <WizardNumberField
        label="对话窗口天数"
        value={draft.policy.conversationWindowDays}
        disabled={disabled}
        onChange={conversationWindowDays =>
          onChange({
            ...draft,
            policy: { ...draft.policy, conversationWindowDays },
          })
        }
      />
      <WizardToggle
        label="回复草稿需要人工审核"
        value={draft.reviewEnabled}
        disabled={disabled}
        onChange={reviewEnabled => onChange({ ...draft, reviewEnabled })}
      />
    </>
  );
}
